import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, CheckCircle2 } from 'lucide-react';
export const PainPoints = () => {
  return <section className="py-24 bg-white relative" data-id="element-178">
      <div className="max-w-5xl mx-auto px-6" data-id="element-179">
        <FadeIn className="text-center mb-16 max-w-3xl mx-auto" data-id="element-180">
          <span className="inline-block text-sm font-semibold tracking-widest uppercase text-accent-rose-deep mb-4" data-id="element-181">
            ¿Te suena familiar?
          </span>
          <h2 className="text-3xl md:text-5xl mb-6 leading-tight" data-id="element-182">
            Querés emprender... pero todo parece{' '}
            <span className="italic text-accent-rose-deep" data-id="element-183">
              difícil, caro o imposible.
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-184">
          <FadeIn direction="up" delay={0.1} className="bg-cream rounded-3xl p-8 md:p-10 shadow-sm border border-nude" data-id="element-185">
            <div className="inline-block px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-bold uppercase tracking-wider mb-5" data-id="element-186">
              Hoy sentís
            </div>
            <ul className="space-y-4" data-id="element-187">
              {['Frustración por depender económicamente.', 'Sentís que estás estancada sin propósito.', 'Ansiedad al ver a otras lograr sus metas.', 'Miedo a invertir y perderlo todo.', 'Creés que no sos lo suficientemente creativa.'].map((text, i) => <li key={i} className="flex items-start gap-3 text-text-brown/80" data-id="element-188">
                  <XCircle className="w-5 h-5 text-red-300 shrink-0 mt-0.5" data-id="element-189" />
                  <span className="leading-relaxed" data-id="element-190">{text}</span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn direction="up" delay={0.2} className="bg-nude rounded-3xl p-8 md:p-10 shadow-soft border border-beige relative overflow-hidden" data-id="element-191">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/40 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-192" />
            <div className="inline-block px-3 py-1 rounded-full bg-accent-rose-deep text-white text-xs font-bold uppercase tracking-wider mb-5 relative z-10" data-id="element-193">
              Vas a lograr
            </div>
            <ul className="space-y-4 relative z-10" data-id="element-194">
              {['Independencia económica desde tu casa.', 'Un negocio aesthetic del que vas a estar orgullosa.', 'Vender por Instagram sin mostrar tu cara.', 'Empezar con muy baja inversión.', 'Un sistema simple, paso a paso, sin experiencia previa.'].map((text, i) => <li key={i} className="flex items-start gap-3 text-text-dark" data-id="element-195">
                  <CheckCircle2 className="w-5 h-5 text-accent-rose-deep shrink-0 mt-0.5" data-id="element-196" />
                  <span className="leading-relaxed font-medium" data-id="element-197">{text}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
};